import { combineReducers } from 'redux'
import example from './example'
import sensorsPonintReducer from './sensorsPonint'

const reducers = combineReducers({
  example,
  sensors: sensorsPonintReducer
})

export default reducers
